import StoreOutlinedIcon from '@material-ui/icons/StoreOutlined';

import List from './List';

export default {
  list: List,
  icon: StoreOutlinedIcon,
};
